export const areHintsEnabledDefaultValue = false;
